import React from 'react';
import styles from './JumpToIAButton.module.scss';
import { Icon } from 'components/common';
import { icons } from 'assets';
import { JumpToButtonProps, directionTypes } from '../types';

const JumpToIAButton = (props: JumpToButtonProps) => {
  const {
    direction, onClick, disabled
  } = props;

  const arrowIcons = {
    [directionTypes.previous]: icons.arrowFillLeft,
    [directionTypes.next]: icons.arrowFillRight
  };

  const title = {
    [directionTypes.previous]: 'Jump To Previous Interactive Area',
    [directionTypes.next]: 'Jump To Next Interactive Area'
  }[direction];

  const containerStyles = [styles.container];
  disabled && containerStyles.push(styles.disabled);

  return (
    <div
      className={containerStyles.join(' ')}
      title={title}
      onClick={disabled ? null : onClick}
    >
      <Icon
        icon={icons.squareWithCorners}
        className={styles.squareIcon}
      />


      <Icon
        icon={arrowIcons[direction]}
        className={styles[direction]}
      />
    </div>
  );
};

export default JumpToIAButton;
